// src/validationRules/fields/rules-phone.js

// Helper to validate phone length based on digits
export function validatePhone({ digits = '', required = false, touched = false }) {
  const len = (digits || '').length

  // Do not show error before user interacts
  if (!touched) {
    return {
      error: false,
      message: '',
    }
  }

  // Required field (main phone)
  if (required) {
    if (len === 0) {
      return {
        error: true,
        message: 'The field cannot be empty.',
      }
    }

    if (len !== 10) {
      return {
        error: true,
        message: 'Please enter exactly 10 digits.',
      }
    }

    return {
      error: false,
      message: '',
    }
  }

  // Optional field (spouse phone)
  if (len === 0) {
    return {
      error: false,
      message: '',
    }
  }

  if (len !== 10) {
    return {
      error: true,
      message: 'Please enter exactly 10 digits.',
    }
  }

  return {
    error: false,
    message: '',
  }
}

// ----- Element Plus form rules -----

// Optional phone (e.g., spouse)
export const rulesPhone = [
  {
    validator: (_, value, callback) => {
      const digits = String(value || '').replace(/\D/g, '')
      const { error, message } = validatePhone({
        digits,
        required: false,
        touched: true,
      })

      if (error) {
        return callback(new Error(message))
      }
      return callback()
    },
    trigger: 'blur',
  },
]

// Required phone (e.g., owner)
export const rulesPhoneRequired = [
  {
    required: true,
    message: 'The field cannot be empty.',
    trigger: ['blur', 'change'],
  },
  {
    validator: (_, value, callback) => {
      const digits = String(value || '').replace(/\D/g, '')

      // If field empty → required rule will catch it
      if (!digits.length) {
        return callback(new Error('The field cannot be empty.'))
      }

      // Must be exactly 10 digits (local)
      if (digits.length <= 10) {
        return callback(new Error('Please enter exactly 10 digits.'))
      }

      return callback()
    },
    trigger: ['blur', 'change'],
  },
]
